// src/components/layout/Layout.jsx
import React, { useState, useContext } from 'react';
import { Box, Grid } from '@mui/material';
import { Outlet } from 'react-router-dom';
import SidebarContent from '../Navbar/Sidebar1';
import { useOrganizations } from '../../customHooks';
import { Navbar } from '../Navbar';
import { ColorModeContext } from '../../index';  // bring in the context

export const Layout = () => {
  const { sidebarModules } = useOrganizations();
  const [openSidebar, setOpenSidebar] = useState(false);
  const handleSidebarOpen = () => setOpenSidebar(prev => !prev);

  // Consume the color mode context
  const { mode, toggleColorMode } = useContext(ColorModeContext);

  return (
    <Grid container sx={{ height: '100vh' }}>
      {sidebarModules && (
        <Grid
          item
          sx={{
            width: openSidebar ? '17%' : 0,
            background: 'linear-gradient(135deg, #D6E8FE 0%, #4d5154 100%)',
            borderRight: '1px solid',
            borderColor: 'grey.300',
            height: '100%',
            overflow: 'auto',
            transition: 'width 0.3s ease',
            display: openSidebar ? 'block' : 'none',
          }}
        >
          <SidebarContent
            sidebarModules={sidebarModules}
            openSidebar={openSidebar}
            setOpenSidebar={setOpenSidebar}
          />
        </Grid>
      )}

      <Grid
        item
        flex={1}
        sx={{ height: '100%', overflow: 'auto', display: 'flex', flexDirection: 'column' }}
      >
        {/* Pass mode & toggleMode into Navbar */}
        <Navbar
          showSideBarOption={!!sidebarModules}
          handleSidebarOpen={handleSidebarOpen}
          mode={mode}
          toggleMode={toggleColorMode}
        />

        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Outlet />
        </Box>
      </Grid>
    </Grid>
  );
};
